<div *ngIf="(vm.loading$ | async) && !(vm.screenshotMode$ | async)" class="splash-container">
  <app-loading [hidden]="vm.hideLoadingSpinner$ | async" [options]="vm.loadingOpts"> </app-loading>
  <img [src]="vm.img | async" alt="" class="company-logo" (click)="clearCaches()" />
  <div [hidden]="vm.hideVersionNumber$ | async" class="software-version">
    {{ vm.versionString | async }}
  </div>
</div>
